import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';

// import * as serviceWorker from './serviceWorker';
import * as Sentry from '@sentry/browser';

if (process.env.REACT_APP_SENTRY_DSN) {
  // tslint:disable-next-line:no-console
  console.log(`Initializing Sentry ...`);
  Sentry.init({ dsn: process.env.REACT_APP_SENTRY_DSN, release: process.env.COMMIT_REF });
}

ReactDOM.render(<App />, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
//serviceWorker.unregister();
